<template>
  <div id="app" class="container-fluid m-0 p-0">
    <transition appear name="fade" class="fast">
      <config-flow-screen v-if="showConfig" :isDemo="isDemoConfig" />
    </transition>
    <div class="row no-gutters" v-if="loggedInUserProfile && !isPublicPage">
      <div class="side-menu-wrapper right-menu">
        <side-menu />
      </div>
      <div ref="content-wrapper" class="content-wrapper">
        <payment-required-banner
          v-if="showPaymentBanner"
          :paymentStatus="loggedInUserProfile.company.paymentStatus"
        />
        <transition
          appear
          mode="out-in"
          enter-active-class="animated fadeIn faster"
          leave-active-class="animated fadeOut faster"
        >
          <router-view />
        </transition>
      </div>
    </div>
    <router-view v-else />
    <transition
      mode="in-out"
      enter-active-class="animated fadeIn faster"
      leave-active-class="animated fadeOut faster"
    >
      <modal
        v-if="modalComponent"
        :component="modalComponent"
        :key="modalKey"
      ></modal>
    </transition>
    <toast :message="toastMessage" ref="toast" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LandingScreen from './components/landing/LandingScreen';
import TopMenu from './components/layouts/TopMenu';
import SideMenu from './components/layouts/SideMenu';
import PaymentRequiredBanner from './components/layouts/PaymentRequiredBanner';
import Modal from './components/shared/modals/Modal';
import ConfigFlowScreen from './components/config/ConfigFlowScreen';
import Toast from './components/shared/elements/Toast.vue';

export default {
  name: 'App',
  components: {
    LandingScreen,
    SideMenu,
    Modal,
    TopMenu,
    ConfigFlowScreen,
    Toast,
    PaymentRequiredBanner,
  },
  data: () => ({
    modalComponent: null,
    showConfig: false,
    isDemoConfig: false,
    toastMessage: '',
    showPaymentBanner: false,
  }),
  created() {
    this.$i18n.locale = this.locale;
    this.$moment.locale(this.$i18n.locale);
    if (this.hasApiKey) {
      this.fetchLoggedInProfile().then((x) => {
        this.$moment.tz.setDefault(this.loggedInUserProfile.timezone);
        if (!process.env.VUE_APP_ISDEMO) {
          window.userGuiding.identify(this.loggedInUserProfile._id, {
            firstName: this.loggedInUserProfile.firstName,
            companyName: this.loggedInUserProfile.company.name,
          });
        }
      });
    } else {
      setTimeout(() => {
        if (!this.isPublicPage) {
          this.$router.push({ name: 'AuthenticateScreen' });
        }
      }, 500);
    }
    this.$eventBus.onShowModal(this, (payload) => {
      this.modalComponent = payload;
    });
    this.$eventBus.onCloseModal(this, () => {
      this.isBlur = !this.isBlur;
      this.modalComponent = null;
    });
    this.$eventBus.onShowConfig(this, (isDemo) => {
      this.showConfig = true;
      this.isDemoConfig = isDemo;
    });
    this.$eventBus.onHideConfig(this, () => {
      this.showConfig = false;
    });
    this.$eventBus.onShowToast(this, (payload) => {
      this.toastMessage = payload.message;
      this.$refs.toast.show();
    });
    if (this.tutorialSeen !== true) {
      setTimeout(() => {
        this.$intro().start(); // start the guide
      }, 2000);
      this.setTutorialSeen();
    }
  },
  mounted() {
    this.checkPaymentStatus();
  },
  methods: {
    ...mapActions({
      fetchLoggedInProfile: 'users/fetchLoggedInProfile',
      setTutorialSeen: 'users/setTutorialSeen',
      listPayments: 'payments/listPayments',
    }),
    checkPaymentStatus() {
      const validUntil = new Date(
        this.loggedInUserProfile.company.paymentStatus.validUntil
      );
      var differenceInTime = validUntil.getTime() - new Date().getTime();
      var differenceInDays = differenceInTime / (1000 * 3600 * 24);
      const hasSubscription =
        this.loggedInUserProfile.company.billingInformation &&
        this.loggedInUserProfile.company.billingInformation
          .stripeSubscriptionId;
      if (
        this.loggedInUser &&
        !this.loggedInUser.company.appSumoLicence &&
        !this.loggedInUserProfile.company.paymentStatus.unlimited &&
        differenceInDays < 10 &&
        !hasSubscription &&
        this.loggedInUserProfile.role == 1
      ) {
        this.showPaymentBanner = true;
      }
    },
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
      hasApiKey: 'hasApiKey',
      tutorialSeen: 'tutorialSeen',
      locale: 'locale',
    }),
    modalKey() {
      if (!this.modalComponent.bind.is.name) {
        return Math.floor(Math.random() * Math.floor(100000));
      }
      return `${this.modalComponent.bind.is.name}_${Math.floor(
        Math.random() * Math.floor(1000)
      )}`;
    },
    isPublicPage() {
      return this.$route.meta && this.$route.meta.isPublic;
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/global.scss';

#app {
  font-family: 'open sans', arial, 'helvetica neue', Helvetica, sans-serif; //'Josefin Sans', sans-serif;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.02);
  min-height: 100vh;
  .right-menu {
    width: 18%;
  }
  .side-menu-wrapper {
    width: 18%;
    display: block;
  }
  .content-wrapper {
    width: 82%;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>

